import React from "react";
import Loadable from "react-loadable";
// import MonthCalendar from '../../_rc-calendar-5.6.2/src/MonthCalendar';
// import RcDatePicker from '../../_rc-calendar-5.6.2/src/Picker';
import GregorianCalendar from "../../_gregorian-calendar";
import classNames from "classnames";
import Icon from "../icon";
import util from "../../_util/util";
const RcDatePicker = Loadable({
  loader: () => import("../../_rc-calendar-5.6.2/src/Picker"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
export default function createPicker(TheCalendar, defaultFormat) {
  return class CalenderWrapper extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        value: this.props.parseDateFromValue(
          this.props.value || this.props.defaultValue
        ),
        minWidth: 0
      };
    }

    componentWillReceiveProps(nextProps) {
      if ("value" in nextProps) {
        this.setState({
          value: nextProps.parseDateFromValue(nextProps.value)
        });
      }
    }

    componentDidMount() {
      let w = 0;
      const { formatPattern } = this.props;
      if (formatPattern) {
        let v = util.formatDate("2017-08-04", formatPattern);
        w = util.getTextWidth(v) + 40;
      }
      this.setState({ minWidth: w });
    }

    clearSelection = e => {
      e.preventDefault();
      e.stopPropagation();
      this.setState({ value: null });
      this.handleChange(null);
    };

    handleChange = value => {
      const props = this.props;
      if (!("value" in props)) {
        this.setState({ value });
      }
      const timeValue = value ? new Date(value.getTime()) : null;
      props.onChange(
        timeValue,
        value ? props.getFormatter().format(value) : ""
      );
    };

    hasPlaceHolder = () => {
      const input = document.createElement("input");
      return "placeholder" in input;
    };

    render() {
      const props = this.props;
      const { formatWithZero = true } = props;
      const locale = props.locale;
      // 以下两行代码
      // 给没有初始值的日期选择框提供本地化信息
      // 否则会以周日开始排
      let defaultCalendarValue = new GregorianCalendar(locale);
      defaultCalendarValue.setTime(Date.now());

      const placeholder =
        "placeholder" in props ? props.placeholder : locale.lang.placeholder;

      const disabledTime = props.showTime ? props.disabledTime : null;

      const calendarClassName = classNames({
        "ant-calendar-time": props.showTime,
        // 'ant-calendar-month': MonthCalendar === TheCalendar,
        "ant-calendar-month": defaultFormat === "yyyy-MM" // 修复MonthCalendar组件异步，样式判断错误问题
      });

      // 需要选择时间时，点击 ok 时才触发 onChange
      let pickerChangeHandler = {
        onChange: this.handleChange
      };
      let calendarHandler = {
        onOk: this.handleChange,
        onClear: this.handleChange,
        // fix https://github.com/ant-design/ant-design/issues/1902
        onSelect: (value, cause) => {
          if (cause && cause.source === "todayButton") {
            this.handleChange(value);
          }
        }
      };
      if (props.showTime) {
        pickerChangeHandler = {};
      } else {
        calendarHandler = {};
      }

      const calendar = (
        <TheCalendar
          formatter={props.getFormatter()}
          formatWithZero={formatWithZero}
          disabledDate={props.disabledDate}
          disabledTime={disabledTime}
          locale={locale.lang}
          timePicker={props.timePicker}
          defaultValue={defaultCalendarValue}
          dateInputPlaceholder={placeholder}
          prefixCls="ant-calendar"
          className={`${calendarClassName} ${props.className || ""}`}
          onOk={props.onOk}
          redDots={props.redDots}
          bgColors={props.bgColors}
          {...calendarHandler}
        />
      );

      // default width for showTime
      const pickerStyle = {};
      if (props.showTime) {
        pickerStyle.width = 180;
      }

      const clearIcon =
        !props.disabled && this.state.value ? (
          <Icon
            type="cross-circle"
            className="ant-calendar-picker-clear"
            onClick={this.clearSelection}
          />
        ) : null;

      const hasPlaceHolder = this.hasPlaceHolder();
      return (
        <span
          className={props.pickerClass}
          style={{ ...pickerStyle, ...props.style }}
        >
          <RcDatePicker
            transitionName={props.transitionName}
            disabled={props.disabled}
            calendar={calendar}
            value={this.state.value}
            prefixCls="ant-calendar-picker-container"
            style={props.popupStyle}
            align={props.align}
            getCalendarContainer={props.getCalendarContainer}
            open={props.open}
            onOpen={props.toggleOpen}
            onClose={props.toggleOpen}
            formatWithZero={formatWithZero}
            {...pickerChangeHandler}
          >
            {({ value }) => {
              return (
                <span>
                  {!hasPlaceHolder &&
                    this.formatValue(value) === "" &&
                    !props.noInput && (
                      <span
                        className="ant-calendar-range-picker-placeholder-ie9"
                        style={{
                          padding: "7px 0 0 5px",
                          textAlign: "left",
                          width: "100%"
                        }}
                      >
                        {placeholder}
                      </span>
                    )}
                  {!!props.noInput ? (
                    ""
                  ) : (
                    <input
                      disabled={props.disabled}
                      readOnly
                      value={this.formatValue(value)}
                      placeholder={placeholder}
                      className={`${
                        props.pickerInputClass
                      } ${props.textDecoration && "text-decoration"}`}
                      style={{ minWidth: this.state.minWidth }}
                    />
                  )}
                  <span className="picker-icon icon-coms-New-schedule cursor-pointer" />
                  {props.noInput && (
                    <span className="text">{this.formatValue(value)}</span>
                  )}
                </span>
              );
            }}
          </RcDatePicker>
        </span>
      );
    }
    formatValue = value => {
      const { formatPattern, format, formatWithZero = true } = this.props;
      let v = "";
      if (value) {
        if (!formatPattern) {
          v = this.props.getFormatter().format(value);
        } else {
          v = this.props.getFormatter(format || "yyyy-MM-dd").format(value);
          v = util.formatDate(v, formatPattern, formatWithZero);
        }
      }
      return v;
    };
  };
}



// WEBPACK FOOTER //
// ./_antd1.11.2/date-picker/createPicker.jsx